var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStep01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.3 86.2",
    enableBackground: "new 0 0 95.3 86.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M48.1,6.4c0-3.1,2.5-5.6,5.6-5.6h30.6c3.1,0,5.6,2.5,5.6,5.6S87.4,12,84.3,12H53.7 C50.6,12,48.1,9.5,48.1,6.4z M53.7,3.8c-1.4,0-2.6,1.2-2.6,2.6S52.3,9,53.7,9h30.6C85.8,9,87,7.9,87,6.4s-1.2-2.6-2.6-2.6H53.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M51.8,30.9H86v27.8H51.8V30.9z M83,33.9H54.8v21.8H83V33.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M66.5,76h19.8c4.5,0,8.3-3.7,8.3-8.3V23.2c0-4.5-3.7-8.2-8.3-8.2c-1,0-1.8-0.8-1.8-1.8V11h-3v2.3 c0,2.6,2.1,4.7,4.8,4.7c2.9,0,5.3,2.4,5.3,5.3v44.5c0,2.9-2.4,5.3-5.3,5.3H66.5V76z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M43.4,62.3h3V23.2c0-2.9,2.4-5.3,5.3-5.3c2.6,0,4.8-2.1,4.8-4.7V11h-3v2.3c0,1-0.8,1.8-1.8,1.8 c-4.5,0-8.3,3.7-8.3,8.2V62.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M23.8,75.3c0-5.5,4.4-9.9,9.9-9.9h19.4c5.5,0,9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9H33.7 C28.3,85.2,23.8,80.8,23.8,75.3z M33.7,68.4c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9h19.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9 H33.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M10.9,76c0.7,0,1.4-0.1,2-0.2l7.5-1.6l0.8-3.2l-8.9,1.9c-1.8,0.4-3.6,0-5.2-1s-2.6-2.6-3-4.4 c-0.4-1.8,0-3.6,1-5.2c1-1.5,2.6-2.6,4.4-3l19-4c3.7-0.8,7.4,1.6,8.2,5.3c0.1,0.5,0.1,0.9,0.1,1.4l3,0c0-0.7-0.1-1.3-0.2-2 c-1.1-5.3-6.4-8.8-11.7-7.7l-19,4c-5.3,1.1-8.8,6.4-7.7,11.7c0.5,2.6,2.1,4.8,4.3,6.2C7.2,75.4,9,76,10.9,76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep01);
export default __webpack_public_path__ + "static/media/icon-step01.3ce611f88ca90aa2356005d4218d60f6.svg";
export { ForwardRef as ReactComponent };